import { GuardedComponent } from '../components/guarded-component';
import InvoiceExceptionReport from '../features/invoice-exception-report/invoice-exception-report';
import { UserPermissionName } from '../models/user-permission-name';

export const InvoiceExceptionReportRoute = {
  path: '/invoice-exception-report',
  name: 'Invoice Exception Report',
  element: (
    <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_INVOICE_EXCEPTION_REPORTS]} showPermissionError>
      <InvoiceExceptionReport />
    </GuardedComponent>
  ),
};
